<template>
    <div class="examReport">
        <div class="title">
            <p>
                <span class="routerName">考试报告</span>
                <span>&nbsp;&nbsp;/&nbsp;&nbsp;</span>
                <span class="planName">{{currentPlan.name}}</span>
                <el-dropdown trigger="click" style="margin-left: 8px;">
                    <span class="el-dropdown-link">
                    <img :src="planImg" alt="">
                    </span>
                    <template #dropdown>
                    <el-dropdown-menu style="max-height:600px;height:auto;overflow-y:auto;">
                        <el-dropdown-item v-for="(item, index) in planList" :key="index" @click.native="changPlan(item)">{{item.name}}</el-dropdown-item>
                    </el-dropdown-menu>
                    </template>
                </el-dropdown>
                <el-button type="primary" plain style="float: right; height: 32px; line-height: 8px;" round @click="goPDF" v-if="isShowPDFBtn">查看考试报告</el-button>
                <el-button type="primary" style="float: right; height: 32px; line-height: 8px; margin-right: 10px;" round @click="openAiDialog">AI生成考试报告</el-button>
            </p>
        </div>
        <div class="examCard examTime">
            <div class="examTime_left">
                <p>考试计划</p>
                <div class="examNum">
                    <div>
                        <p class="number">{{info.courseCount}}</p>
                        <p class="descript">考试科目</p>
                    </div>
                    <div>
                        <p class="number">{{info.placeCount}}</p>
                        <p class="descript">考点数</p>
                    </div>
                </div>
                <div class="examTime_info">
                    <p >报名方式：<span>{{info.signType}}</span></p>
                    <p >报名时间：<span>{{info.signDate}}</span></p>
                    <p >缴费时间：<span>{{info.payDate}}</span></p>
                    <p >模考时间：<span>{{info.simulateDate}}</span></p>
                    <p >考试时间：<span>{{info.examDate}}</span></p>
                </div>
            </div>
            <div class="examTime_right">
                <p>考试城市分布</p>
                <div style="width: 100%; height: 100%;" id="map-chart">

                </div>
            </div>
        </div>

        <div class="examCard examInfoNum">
            <div class="examInfo_item">
                <p>报名数据</p>
                <div>
                    <div>
                        <p class="number">{{dataInfo.preRegStuCount}}</p>
                        <p class="descript">预报名人数</p>
                    </div>
                    <div>
                        <p class="number">{{dataInfo.signStuCount}}</p>
                        <p class="descript">报名总人数</p>
                    </div>
                    <div>
                        <p class="number">{{dataInfo.courseCount}}</p>
                        <p class="descript">报考课程数</p>
                    </div>
                    <div>
                        <p class="number">{{dataInfo.placeCount}}</p>
                        <p class="descript">报名考点数</p>
                    </div>
                </div>
            </div>
            <div class="examInfo_item">
                <p>审核&缴费数据</p>
                    <div>
                        <div>
                            <p class="number">{{dataInfo.passStuCount}}</p>
                            <p class="descript">审核通过人数</p>
                        </div>
                        <div>
                            <p class="number">{{dataInfo.unpassStuCount}}</p>
                            <p class="descript">审核不通过人数</p>
                        </div>
                        <div>
                            <p class="number">{{dataInfo.payStuCount}}</p>
                            <p class="descript">缴费人数</p>
                        </div>
                        <div>
                            <p class="number">{{dataInfo.sumMoney}}</p>
                            <p class="descript">缴费总额</p>
                        </div>
                    </div>
                <!-- 
                    <div>
                        <div v-if="currentPlan.needAudit != 0">
                            <p class="number">{{dataInfo.passStuCount}}</p>
                            <p class="descript">审核通过人数</p>
                        </div>
                        <div v-if="currentPlan.needAudit != 0">
                            <p class="number">{{dataInfo.unpassStuCount}}</p>
                            <p class="descript">审核不通过人数</p>
                        </div>
                        <div v-if="currentPlan.isPay != 0">
                            <p class="number">{{dataInfo.payStuCount}}</p>
                            <p class="descript">缴费人数</p>
                        </div>
                        <div v-if="currentPlan.isPay != 0">
                            <p class="number">{{dataInfo.sumMoney}}</p>
                            <p class="descript">缴费总额</p>
                        </div>
                    </div> 
                -->
            </div>
            <div class="examInfo_item">
                <p>模拟考试数据</p>
                <div>
                    <div>
                        <p class="number">{{dataInfo.shouldSimulate}}</p>
                        <p class="descript">应模考人数</p>
                    </div>
                    <div>
                        <p class="number">{{dataInfo.examedSimulate}}</p>
                        <p class="descript">实际模考人数</p>
                    </div>
                    <div>
                        <p class="number">{{dataInfo.unexamSimulate}}</p>
                        <p class="descript">未参加模考人数</p>
                    </div>
                </div>
            </div>
        </div>

        <!-- AI生成考试报告弹窗 -->
        <el-dialog title="AI生成考试报告" :visible.sync="aiDialogVisible" width="700px" :close-on-click-modal="false">
            <div class="aiCheckTags" v-if="aiCheckList.length > 0">
                <el-tag v-for="(item, index) in aiCheckList" :key="index" style="margin: 0 8px 8px 0;">{{ item }}</el-tag>
            </div>
            <el-table :data="aiProgressList" border style="width: 100%; margin-top: 16px;" v-if="aiProgressList.length > 0">
                <el-table-column prop="itemName" label="检测名称"></el-table-column>
                <el-table-column prop="courseName" label="课程名称"></el-table-column>
                <el-table-column prop="status" label="状态">
                    <template slot-scope="scope">
                        <span v-if="scope.row.status == 1">待处理</span>
                        <span v-else-if="scope.row.status == 2">处理中</span>
                        <span v-else-if="scope.row.status == 3" style="color: #67C23A;">处理成功</span>
                        <span v-else-if="scope.row.status == 4" style="color: #F56C6C;">处理失败</span>
                    </template>
                </el-table-column>
                <el-table-column prop="executeDesc" label="描述"></el-table-column>
            </el-table>
            <div style="text-align: right; margin-top: 20px;">
                <el-button type="primary" @click="generateAiReport" v-if="aiProgressList.length === 0">生成AI报告</el-button>
                <el-button type="primary" @click="generateAiReport" v-if="aiProgressList.length > 0 && !hasPendingOrProcessing">重新生成AI报告</el-button>
                <el-button type="primary" plain @click="viewAiReport">查看考试报告</el-button>
            </div>
        </el-dialog>

        <ots-table-group-new
            :requestForm='requestForm'
            @search="search"
            :tableHeader="tableHeader"
            :tableData="tableData"
            :pagination="pagination"
            @changeNum="changeNum"
            @changePage="changePage"
        ></ots-table-group-new>

    </div>
</template>
<script>
import { 
    examReportInfoFN, 
    examReportCountFN, 
    getPagelist ,
    examReportAiCheckListAPI,
    examReportAiCheckProgressAPI,
    examReportAiCheckTaskAPI
} from '@/http/modules/examReport'

import { 
    getSelectPlanFn 
} from '@/http/modules/examSet/examBatch'


export default {
    name:"examReport",
    data(){
        return {
            planImg: require('@/assets/img/courseChange.png'),
            planList: [],
            currentPlan: '',
            currentPlanID: '',
            info: {
                courseCount: 0,
                placeCount: 0,
            },
            dataInfo: {},
            requestForm: {
                planId: '',
                page: 1,
                size: 10,
            },
            tableData: [],
            tableHeader: [
                {
                    title: "考试科目",
                    prop: "courseName",
                    fixed: "left"
                },
                {
                    title: "预报名人数",
                    prop: "preRegStuCount",
                },
                {
                    title: "报名人数",
                    prop: "signStuCount",
                },

                {
                    title: "参考人数",
                    prop: "examedStuCount",
                },
                {
                    title: "缺考人数",
                    prop: "unexamStuCount",
                },
                {
                    title: "参考率",
                    prop: "examedPercent",
                },
                {
                    title: "缴费人数",
                    prop: "payStuCount",
                },

            ],
            pagination: {
                total: 0
            },
            canvasData: [],

            isShowPDFBtn: false,

            aiDialogVisible: false,
            aiCheckList: [],
            aiProgressList: [],
        }
    },
    created(){
        this.initData()
    },
    computed: {
        hasPendingOrProcessing() {
            return this.aiProgressList.some(item => item.status == 1 || item.status == 2)
        }
    },
    watch: {
        'currentPlan': 'planIsChange'
    },
    methods: {
        /**
         * @param { 考试报告PDF }
         */
        goPDF() {
            this.$router.push({
                path: "/examReportPDF",
                query: { planId: this.requestForm.planId },
            });
        },

        /***************************************
         * @examEvery 地图散点图
         ***************************************/        
        examEvery(val){
            var dataValue = val ? val : []
            var chartDom = document.getElementById("map-chart")
            var myChart = this.$echarts.init(chartDom)
            let option = {
                tooltip: {
                    show: false
                },
                geo: {
                    map: "china",
                    roam: false,// 一定要关闭拖拽
                    zoom: 1.23,
                    center: [105, 36], // 调整地图位置
                    label: {
                        normal: {
                        show: false, //关闭省份名展示
                        fontSize: "10",
                        color: "#FFF"
                        },
                        emphasis: {
                            show: false
                        }
                    },
                },
                series: [
                    {
                        type: "map",
                        map: "china",
                        roam: false,
                        zoom: 1.23,
                        center: [105, 36],
                        showLegendSymbol: false,
                        label: {
                        normal: {
                            show: false
                        },
                        emphasis: {
                            show: false,
                            textStyle: {
                                color: "#FFF"
                            }
                        }
                        },
                        itemStyle: {
                            normal: {
                                areaColor: "#FFF",
                                borderColor: "#ccc",
                                borderWidth: 0.5
                            },
                            emphasis: {
                                areaColor: "#FFF",
                                shadowOffsetX: 0,
                                shadowOffsetY: 0,
                                shadowBlur: 5,
                                borderWidth: 0,
                                shadowColor: "rgba(0, 0, 0, 0.5)"
                            }
                        }
                    },
                    // {
                    //     name: "",
                    //     type: "scatter",
                    //     coordinateSystem: "geo",
                    //     data: val,
                    //     symbol: "circle",
                    //     symbolSize: 5,
                    //     hoverSymbolSize: 10,
                    //     tooltip: {
                    //         // formatter(value) {
                    //         //     console.log(value);
                    //         //     return value.data.name + "<br/>" + "考点数：" + "22";
                    //         // },
                    //     show: true
                    //     },
                    //     encode: {
                    //     value: 2
                    //     },
                    //     label: {
                    //     formatter: "{b}",
                    //     position: "right",
                    //     show: false
                    //     },
                    //     itemStyle: {
                    //     shadowBlur: 2,
                    //     shadowColor: "#333",
                    //         color: "#006AFF",
                    //         emphasis: {
                    //             areaColor: "#FFF",
                    //             shadowOffsetX: 0,
                    //             shadowOffsetY: 0,
                    //             shadowBlur: 5,
                    //             borderWidth: 0,
                    //             shadowColor: "rgba(0, 0, 0, 0.5)"
                    //         }
                    //     },
                    //     emphasis: {
                    //         label: {
                    //             show: false
                    //         }
                    //     }
                    // },
                    {
                        name: "",
                        type: "effectScatter",
                        coordinateSystem: "geo",
                        data: dataValue,
                        symbolSize: 10,
                        tooltip: {
                        show: false
                        },
                        encode: {
                        value: 2
                        },
                        showEffectOn: "render",
                        rippleEffect: {
                            brushType: "stroke",
                            color: "#006AFF",
                            period: 9,
                            scale: 5
                        },
                        hoverAnimation: true,
                        label: {
                            formatter: "{b}",
                            position: "right",
                            show: true
                        },
                        itemStyle: {
                            color: "#006AFF",
                            shadowBlur: 2,
                            shadowColor: "#333"
                        },
                        zlevel: 1
                    }
                ]
            };
            option && myChart.setOption(option)
        },

        /***************************************
         * @initData 初始化数据
         ***************************************/
        initData(){            
            getSelectPlanFn({needAudit: 4}).then( ({data}) =>{
                this.planList = data
                this.currentPlan = data[0]
                this.requestForm.planId = data[0].id
            })
        },

        /***************************************
         * @changPlan 批次切换
         ***************************************/
        changPlan(value){
            this.currentPlan = value
            this.requestForm.planId = value.id
        },
  
        /***************************************
         * @planIsChange 批次切换查询考试计划
         ***************************************/
        planIsChange(){
            // 考试成绩分布
            examReportInfoFN({planId: this.currentPlan.id}).then(res=>{
                if (res.code == 1)  {
                    this.info = res.data
                    let siteData = this.info.placeSites.split('#').map(e=>{
                        return [e.split(',')[1], e.split(',')[0]]
                    })
                    var data = []
                    for (var key in siteData) {
                        data.push({ name: '', value: siteData[key] })
                    }
                    this.examEvery(data)

                    this.isShowPDFBtn = true
                } else {
                    this.isShowPDFBtn = false
                }


            }).catch(err=>{
                this.info.placeCount = 0
                this.info.courseCount = 0
                this.examEvery()
            })
            // 报名/审核/缴费/模拟考
            examReportCountFN({planId: this.currentPlan.id}).then(res=>{
                if (res.code == 1) {
                    this.dataInfo = res.data
                }
            })
            // 是否显示缴费列
            // if (this.currentPlan.isPay == 0) {
            //     this.tableHeader.map((e,i)=>{
            //         if (e.prop == 'payStuCount') {
            //             this.tableHeader[i].type = true
            //         }
            //     })
            // } else {
            //     this.tableHeader.map((e,i)=>{
            //         if (e.prop == 'payStuCount') {
            //             this.tableHeader[i].type = false
            //         }
            //     })
            // }
            // 重新搜索
            this.search()
        },

        /***************************************
         * @search 查询表格
         ***************************************/
        search(){
            let params = {...this.requestForm}
            getPagelist(params).then( res => {
                if (res.code == 1) {
                    this.tableData = res.data.records
                    this.pagination.total  = res.data.total
                }
            })
        },

        changeNum(num) {
            this.requestForm.size = num
            this.search()
        },

        /***************************************
         * @openAiDialog 打开AI弹窗
         ***************************************/
        openAiDialog() {
            this.aiDialogVisible = true
            this.aiCheckList = []
            this.aiProgressList = []
            examReportAiCheckListAPI().then(res => {
                if (res.code == 1) {
                    this.aiCheckList = res.data || []
                }
            })
            this.getAiProgress()
        },

        /***************************************
         * @getAiProgress 查询AI检测进度
         ***************************************/
        getAiProgress() {
            examReportAiCheckProgressAPI({ planId: this.requestForm.planId }).then(res => {
                if (res.code == 1) {
                    this.aiProgressList = res.data || []
                }
            })
        },

        /***************************************
         * @generateAiReport 生成/重新生成AI报告
         ***************************************/
        generateAiReport() {
            examReportAiCheckTaskAPI({ planId: this.requestForm.planId }).then(res => {
                if (res.code == 1) {
                    this.$message.success('AI报告生成任务已发起')
                    this.getAiProgress()
                }
            })
        },

        /***************************************
         * @viewAiReport 查看考试报告
         ***************************************/
        viewAiReport() {
            this.aiDialogVisible = false
            this.goPDF()
        },

        changePage(p) {
            this.requestForm.page = p
            this.search()
        },
    }
}
</script>
<style scoped lang="less">
    .examReport {
        // 标题 -- 批次名
        .title {
            height: 32px;
            p {
                .routerName {
                    font-size: 14px;
                    color: #9299A6;
                }
                .planName {
                    font-size: 24px;
                    font-weight: 500;
                    color: #2D2F33;
                }
                .el-dropdown-link {
                    cursor: pointer;
                    color: var(--el-color-primary);
                    display: flex;
                    align-items: center;
                }
            }
        }

        // 通用 div
        .examCard  {
            display: flex;
            margin-top: 24px;
        }

        @media screen and (max-width: 1620px) {
            .examCard.examTime {
                height: 360px!important;
            }
        }

        .examCard.examTime {
            height: 300px;
            .examTime_left {
                padding: 20px;
                // width: calc(100% - 570px);
                width: 100%;
                background: #FFF;
                border-radius: 4px;
                &>p {
                    font-size: 18px;
                    font-weight: 500;
                    color: #2D2F33;
                    line-height: 24px;
                    margin-bottom: 20px;
                }
                .examTime_info {
                    display: flex;
                    flex-wrap: wrap;
                    &>p {
                        width: 50%;
                        margin-bottom: 20px;
                        color: #9299A6;
                        font-size: 14px;
                        span {
                            color: #2D2F33;
                        }
                    }
                }

                @media screen and (max-width: 1620px) {
                    .examTime_info {
                        &>p{
                            width: 100%;
                        }
                    }
                }

                // 考试计划数量
                .examNum {
                    width: 100%;
                    height: 85px;
                    margin-bottom: 24px;
                    display: flex;
                    justify-content: space-around;
                    border-bottom: 1px dotted #F1F2F5 ;

                    &>div {
                        .number {
                            font-size: 26px; 
                            color: #2D2F33;
                            line-height: 40px;
                            text-align: center;
                        }
                        .descript {
                            color: #737780;
                            font-size: 13px;
                            text-align: center;
                        }
                    }

                }
            }
            .examTime_right {
                // min-width: 570px;
                margin-left: 16px;
                min-width: 538px;
                background: #FFF;
                border-radius: 4px;
                box-sizing: border-box;
                position: relative;

                &>p{
                    position: absolute;
                    top: 20px;
                    left: 20px;                
                    font-size: 18px;
                    color: #2D2F33;
                    font-weight: 500;
                }
            }
        }

        .examCard.examInfoNum {
            border-radius: 4px;
            width: 100%;
            height: 145px;

            .examInfo_item {
                border-radius: 4px;
                height: 145px;
                width: 33%;
                // min-width: 554px;
                background: #FFF;
                padding: 19px 16px;
                box-sizing: border-box;
                &>p{
                    height: 24px;
                    font-size: 18px;
                    font-weight: 500;
                    color: #2D2F33;
                    line-height: 24px;
                    margin-bottom: 20px;
                }
                &>div {
                    display: flex;
                    justify-content: space-around;
                    .number{
                        font-size: 26px;
                        color: #2D2F33;
                        line-height: 40px;
                        text-align: center;
                    }
                }

            }
            .examInfo_item:nth-of-type(1),.examInfo_item:nth-of-type(2) {
                margin-right: 16px;
            }
        }

        .aiCheckTags {
            padding: 10px 0;
            border-bottom: 1px solid #EBEEF5;
        }
    }
</style>
